<ng-container *ngIf="model">
  <span [kitText]="model.message"></span>
  <button *ngIf="model.isClosable" type="button" class="close" aria-label="Close" (click)="discard($event)">
    <span aria-hidden="true">&times;</span>
  </button>
</ng-container>